export function isPassTooShort(pass: string) {
  return pass?.length < 12;
}
